var _utils = (function() {
  return {
    handle: function (value) {
      return value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      //return value.toLowerCase().replace(' ', '-');      
    },
    
    resize_img: function(src, size) {
      var resized = src || '';
      resized = resized.replace('.png', `_${size}.png`);
      resized = resized.replace('.jpg', `_${size}.jpg`);

      return resized;    
    },
    
    formatMoney: function(value) {
      const usd = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });

      return usd.format(value / 100);    
    },
    
    addItemsToCart: function(items) {
      return $.post('/cart/add.js', {
        items: items
      }, null, 'json');
    },
    
    getRandomUniqId: function() {
      return '_' + Math.random().toString(36).substr(2, 9);
    },
    
    getCart: function() {
      return $.getJSON('/cart.js');
    },
    
    refreshCart: function() {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    },
    
    splitNumber: function(num, parts) {
      let n = Math.floor(num / parts);
      const arr = [];

      for (let i = 0; i < parts; i++){
        arr.push(n)
      }
      if(arr.reduce((a, b)=> a + b,0) === num){
        return arr;
      }
      for(let i = 0; i < parts; i++) {
        arr[i]++;
        if(arr.reduce((a, b) => a + b, 0) === num){
          return arr;
        }
      }
      
      return arr;
    }
  };
})();

/* Vue Filters */
Vue.filter('resize_img', function(src, size) {
  return _utils.resize_img(src, size);
});

Vue.filter('handle', function(value) {
  return _utils.handle(value);
});  

Vue.filter('format_money', function(value) {
  return _utils.formatMoney(value);
});
/* End -- Vue filters */

function initKits() {
  const SETTINGS = {
    kit_discount_percent: 16
  }
  
  var kits_vm = new Vue({
    el: '#product-form-kit',
    
    data: {asset_url, file_url, kits},
    
    computed: {
      kit_dd: function() {
        var kit_dd = (this.kits.kit_d + '').split('.');
        if (this.isFixedPrice()) {
          kit_dd = (this.kits.kit_f + '').split('.');
        }
        return kit_dd;
      },
      
      kit_blocks: function() {
        var blocks = this.kits.blocks;
        
        blocks.forEach(block => {
          block.selected_product = block.products.find(product => product.selected);
        });
        
        return blocks;
      },
      
      all_products: function() {
        var products = [];
        this.kit_blocks.forEach(block => {
          block.products.forEach(product => {
            products.push(product);
          });
        });
        
        return products;
      },
      
      selected_products: function() {
        return this.all_products.filter(product => product.selected);
      },
      
      kit_price_original: function() {
        var selected_variants = this.selected_products.map(product => product.selected_variant);
        var total_price = selected_variants.reduce(function(sum, variant) {
          return sum + variant.price;
        }, 0);
        
        return total_price;
      },
      
      kit_price: function() {
        var kit_f = parseFloat(this.kits.kit_f.split("").reverse().join("")) * 100;
        var kit_d = parseFloat(this.kits.kit_d.split("").reverse().join(""));
        var kit_price = this.kit_price_original * (1-kit_d);
        
        if (this.isFixedPrice()) {
          kit_price = kit_f;
        }
        
        return kit_price;
      }
    },
    
    mounted: function() {},
    
    methods: {
      getAssetUrl: function(value) {
        return `${asset_url}${_utils.handle(value)}`;
      },
      
      getFileUrl: function (value) {
        return `${file_url}${_utils.handle(value)}`;
      },      

      getColorSwatchUrl: function (value) {
        return `${file_url}${_utils.handle(value)}.png`;
      },
      
      getVariantImage: function(product) {
        var color_option = product.options_with_values.find(o => o.name == 'Color');
        var color_option_id = 'option' + color_option.position;
        var color = product.selected_variant[color_option_id];
        var featured_img = product.media.find(m => m.alt && m.alt.indexOf(color) !== -1) || product.selected_variant.featured_image;
        //console.log({color_option, color_option_id, color, featured_img});
        
        return featured_img.src;
      },
      
      isFixedPrice: function() {
        return this.kits.kit_f > 0;
      },
      
      isColorOption: function(option) {
        return ['color'].indexOf(option.name.toLowerCase()) !== -1;
      },
      
      isOptionChecked: function(product, valueIndex) {
        return product.selected_values[valueIndex] !== undefined;
      },
      
      isSoldOut: function(product, option, value) {
        var matching_variants = product.variants.filter(v => {
          return _.intersection(v.options, [value]).length > 0;
        });
        
        var leading_variants = matching_variants.filter(v => {
          return _.intersection(product.selected_variant.options, v.options).length > 0;
        });
        
        var is_sold_out = leading_variants.length && leading_variants.filter(v => !v.available).length == leading_variants.length;
        //console.log({option, value, leading_variants, sold_out_flag});
        
        return is_sold_out;
      },
      
      changeSelectedProduct: function(e, blockIndex) {
        var _this = this;
        
        var $select = $(e.target);
        var product_id = $select.val();
        
        _this.kits.blocks[blockIndex].products.forEach(product => {
          product.selected = false;
          
          if (product.id == product_id) {
            product.selected = true;
          }
        });
      },      
      
      changeVariant: function(e, product) {
        var $target = $(e.target);
        if (e.target.type == 'select-one') {
          var $swatch_container = $target.closest('.options-dropdown');
          var value = $target.val();
          var $input = $swatch_container.find(`input[value="${value}"]`);
          if ($input.length) {
            $input.prop('checked', true);
            $input[0].dispatchEvent(new Event('change', {'bubbles': true}));
            return;
          }
        }
        var $product = $(e.target).closest('.kit-item');
        var selected_options_values = $product.find('input[type=radio]:checked').map((index, item) => item.value).toArray();
        product.selected_variant = product.variants.find(v => _.difference(v.options, selected_options_values).length == 0);
      },
      
      selectValue: function(e, product, value, valueIndex) {
        product.selected_values[valueIndex] = value;
      },
      
      addKitToCart: function(e) {
        var kit_id = `${this.kit_dd[0]}${_utils.getRandomUniqId()}_${this.kit_dd[1]}`;
        
        var items = this.selected_products.map(product => {
          return {
            id: product.selected_variant.id,
            quantity: 1,
            properties: {
              '__kit_title': this.kits.kit_product.title,
              '__kit_handle': this.kits.kit_product.handle,
              '__kit': kit_id,
              '__kit_type': (this.isFixedPrice()) ? 'fixed': 'percent'
            }
          }
        });
        
        _utils.addItemsToCart(items)
        .then(response => {
          _utils.refreshCart();
        })
        .catch(error => {
          console.error(error);
        });
      }
    }
  });  
}

(function() {
  initKits();
})();